import { AudioOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Input } from 'antd';
import React, { FC } from 'react';
const { Search } = Input;

type Props = {
    search: string;
    setSearch: Function;
    onSearch: Function;
    disabled?: boolean;
    placeholder?: string;
};

const CustomSearch = styled(Search)`
    .ant-input-search-button {
        border-radius: 0px 6px 6px 0px !important;
    }
    &.ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:last-child) {
        border-radius: 6px 0px 0px 6px !important;
    }
`;

const SearchBox: FC<Props> = ({ search, setSearch, onSearch, disabled, placeholder = 'Search' }) => {
    return (
        <div>
            {/* <input className="px-2 py-1 outline-none border border-borderGreyAl1 h-full w-full" /> */}
            {/* <SearchIcon /> */}
            <CustomSearch
                disabled={disabled}
                onChange={(e) => {
                    setSearch(e.target.value);
                }}
                value={search}
                placeholder={placeholder}
                allowClear
                onSearch={(val) => {
                    onSearch(val);
                }}
                style={{ borderRadius: 6, width: 220 }}
            />
        </div>
    );
};

export default SearchBox;
